import React from 'react';

import {
  AgeAttributeCard,
  GenderAttributeCard,
  UpperBodyAttributeCard,
  LowerBodyAttributeCard,
  HeadwearAttributeCard,
  ShoesAttributeCard,
  BackpackAttributeCard,
} from '@vlabs/monokit/shared/ui/atribute-cards';
import cn from 'classnames';

import st from './tabs.module.sass';

function BodyAttributesTab({
  event,
  className,
}) {
  const gender = event?.body_basic_attributes?.apparent_gender;
  const age = event?.body_basic_attributes?.apparent_age;
  const upperBody = event?.upper_body;
  const lowerBody = event?.lower_body;
  const backpack = event?.accessories?.backpack;

  return (
    <div className={cn(st.TabPanel, className)}>
      {gender !== undefined && <GenderAttributeCard gender={gender} />}
      {age !== undefined && <AgeAttributeCard age={age} />}

      {!!upperBody && <UpperBodyAttributeCard values={upperBody} />}
      {!!lowerBody && <LowerBodyAttributeCard values={lowerBody} />}
      {!!upperBody && (
      <HeadwearAttributeCard
        color={upperBody.headwear.apparent_color}
        headwear={upperBody.headwear.state}
      />
      )}
      {!!lowerBody && <ShoesAttributeCard shoes={lowerBody.shoes} />}
      {!!backpack && <BackpackAttributeCard backpack={backpack.state} />}
    </div>
  );
}

export { BodyAttributesTab };
